import { WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface OfflineNoticeProps {
  queueCount?: number;
}

export function OfflineNotice({ queueCount = 0 }: OfflineNoticeProps) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2 rounded-lg bg-amber-50 border border-amber-200 px-3 py-2 text-sm text-amber-800">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>{t('Feedback.offline.notice')}</span>
      {queueCount > 0 && (
        <span className="ml-auto text-xs text-amber-600">
          {t('Feedback.offline.pending', { count: queueCount })}
        </span>
      )}
    </div>
  );
}
